export default __webpack_public_path__ + "assets/objectTypeClicked/skatu_tornis_zals.png";